(function () {
  var KEY = 'koji_cookie_consent_v1';
  var MAX_AGE = 180 * 24 * 60 * 60 * 1000; // 6 mesi, come indicato dal Garante

  var root = document.getElementById('kojiCookie');
  if (!root) return;
  var banner = root.querySelector('[data-kc-banner]');
  var prefs = root.querySelector('[data-kc-prefs]');
  var inputs = root.querySelectorAll('[data-kc-pref]');
  var lastFocus = null;

  function readLocal() {
    try {
      var r = JSON.parse(localStorage.getItem(KEY));
      return r && r.t && r.c ? r : null;
    } catch (e) { return null; }
  }
  function writeLocal(c) {
    try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), c: c })); } catch (e) {}
  }

  // Collega la scelta al sistema di consenso di Shopify, che pixel e app leggono
  function withApi(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy && typeof S.customerPrivacy.setTrackingConsent === 'function') {
      cb(S.customerPrivacy);
      return;
    }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        cb(!err && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null);
      });
      return;
    }
    cb(null);
  }

  function pushToShopify(c) {
    withApi(function (p) {
      if (!p || typeof p.setTrackingConsent !== 'function') return;
      try {
        p.setTrackingConsent(
          { analytics: !!c.a, marketing: !!c.m, preferences: !!c.p, sale_of_data: !!c.m },
          function () {}
        );
      } catch (e) {}
    });
  }

  function hideAll() {
    root.hidden = true;
    banner.hidden = true;
    prefs.hidden = true;
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function show(panel) {
    root.hidden = false;
    banner.hidden = panel !== 'banner';
    prefs.hidden = panel !== 'prefs';
    var target = panel === 'banner' ? banner : prefs;
    setTimeout(function () { target.focus({ preventScroll: true }); }, 30);
  }

  function setInputs(c) {
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].checked = !!c[inputs[i].getAttribute('data-kc-pref')];
    }
  }

  function save(c) {
    writeLocal(c);
    pushToShopify(c);
    hideAll();
    try { document.dispatchEvent(new CustomEvent('koji:cookie-consent', { detail: c })); } catch (e) {}
  }

  var NONE = { p: false, a: false, m: false };
  var ALL = { p: true, a: true, m: true };

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t) return;
    if (t.hasAttribute('data-kc-accept')) save(ALL);
    else if (t.hasAttribute('data-kc-reject')) save(NONE);
    else if (t.hasAttribute('data-kc-close')) save(NONE);
    else if (t.hasAttribute('data-kc-customize')) { setInputs(NONE); show('prefs'); }
    else if (t.hasAttribute('data-kc-save')) {
      var c = { p: false, a: false, m: false };
      for (var i = 0; i < inputs.length; i++) c[inputs[i].getAttribute('data-kc-pref')] = inputs[i].checked;
      save(c);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) save(NONE);
  });

  function openPrefs(from) {
    lastFocus = from || null;
    var cur = readLocal();
    setInputs(cur ? cur.c : NONE);
    show('prefs');
  }

  // Link "Gestisci cookie" (footer o informativa): href="#cookie-preferenze"
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#cookie-preferenze"]');
    if (!a) return;
    e.preventDefault();
    openPrefs(a);
  });
  if (window.location.hash === '#cookie-preferenze') openPrefs(null);

  var stored = readLocal();
  if (stored && Date.now() - stored.t < MAX_AGE) {
    // Scelta gia fatta: riallinea Shopify se il suo cookie fosse scaduto
    pushToShopify(stored.c);
  } else if (window.location.hash !== '#cookie-preferenze') {
    show('banner');
  }
})();